import styled from "styled-components"

export default styled.div`
  max-width: ${({ theme, wide }) =>
    wide ? theme.maxWidthWide : theme.maxWidth};
  margin: 0 auto;
  padding: 0 2rem;
`
